module.exports = __webpack_public_path__ + "static/media/menu-zap-icon-hover.49ee25f9.svg";